module.exports = __webpack_public_path__ + "static/media/icon_wechat.8e6ecb41.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/about/icon_wechat.svg
// module id = 153
// module chunks = 0